import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3df23f44"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "primary-container" }
const _hoisted_2 = { class: "shadow-lg p-6 bg-white rounded-2xl mx-auto" }
const _hoisted_3 = { class: "text-dark-grey font-medium text-2xl mb-6" }
const _hoisted_4 = { class: "text-sm mb-6" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_6 = { class: "w-full mt-4 flex gap-x-4" }
const _hoisted_7 = {
  key: 0,
  class: "fontbottom-1/2 left-1/2 -translate-x-1/2 translate-y-1/2"
}
const _hoisted_8 = {
  key: 0,
  class: "form-card-tabs-container"
}
const _hoisted_9 = { class: "columns-2 mt-4" }
const _hoisted_10 = { class: "columns-2 mt-4" }
const _hoisted_11 = { class: "columns-2 mt-4" }
const _hoisted_12 = { class: "columns-2 mt-4" }
const _hoisted_13 = { class: "columns-2 mt-4" }
const _hoisted_14 = { class: "columns-2" }
const _hoisted_15 = { class: "columns-2 mt-4" }
const _hoisted_16 = { class: "columns-2 mt-4" }
const _hoisted_17 = { class: "columns-1 mt-4" }
const _hoisted_18 = { class: "columns-1 mt-4" }
const _hoisted_19 = { class: "m-0 pt-4 pb-4" }
const _hoisted_20 = { class: "text-base font-semibold mb-4" }
const _hoisted_21 = {
  key: 0,
  class: "fontbottom-1/2 left-1/2 -translate-x-1/2 translate-y-1/2"
}
const _hoisted_22 = { class: "text-[#344054] text-md font-semibold border border-[#D0D5DD] px-3 py-2 bg-white rounded-lg" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("h2", { class: "text-base font-semibold mb-4 mt-4" }, "MATHS classes")
], -1))
const _hoisted_24 = { class: "text-[#344054] text-md font-semibold border border-[#D0D5DD] px-3 py-2 bg-white rounded-lg" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("h2", { class: "text-base font-semibold mb-4 mt-4" }, " ENGLISH classes ")
], -1))
const _hoisted_26 = { class: "text-[#344054] text-md font-semibold border border-[#D0D5DD] px-3 py-2 bg-white rounded-lg" }
const _hoisted_27 = { class: "text-base font-semibold mb-4 mt-3" }
const _hoisted_28 = {
  key: 0,
  class: "fontbottom-1/2 left-1/2 -translate-x-1/2 translate-y-1/2"
}
const _hoisted_29 = { class: "grid grid-cols-1 gap-4 sm:grid-cols-2" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-shrink-0" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-indigo text-[#155EEF] [&>svg]:stroke-current [&>svg]:h-8 [&>svg]:w-8" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      width: "32",
      height: "32",
      viewBox: "0 0 32 32",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        d: "M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z",
        fill: "#F2F4F7"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        d: "M0.25 16C0.25 7.30152 7.30152 0.25 16 0.25C24.6985 0.25 31.75 7.30152 31.75 16C31.75 24.6985 24.6985 31.75 16 31.75C7.30152 31.75 0.25 24.6985 0.25 16Z",
        stroke: "black",
        "stroke-opacity": "0.08",
        "stroke-width": "0.5"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        d: "M22.6666 23.5C22.6666 22.337 22.6666 21.7555 22.5231 21.2824C22.1999 20.217 21.3662 19.3834 20.3009 19.0602C19.8277 18.9167 19.2462 18.9167 18.0832 18.9167H13.9166C12.7536 18.9167 12.1721 18.9167 11.699 19.0602C10.6336 19.3834 9.79995 20.217 9.47678 21.2824C9.33325 21.7555 9.33325 22.337 9.33325 23.5M19.7499 12.25C19.7499 14.3211 18.071 16 15.9999 16C13.9289 16 12.2499 14.3211 12.2499 12.25C12.2499 10.1789 13.9289 8.5 15.9999 8.5C18.071 8.5 19.7499 10.1789 19.7499 12.25Z",
        stroke: "#667085",
        "stroke-width": "1.66667",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      })
    ])
  ])
], -1))
const _hoisted_31 = { class: "min-w-0 flex-1" }
const _hoisted_32 = { class: "focus:outline-none" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "absolute inset-0",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_34 = { class: "text-sm font-medium text-gray-900 text-[#155EEF] leading-6" }
const _hoisted_35 = { class: "text-gray-900 text-xs leading-6" }
const _hoisted_36 = {
  key: 0,
  class: "truncate text-sm text-gray-500 leading-6"
}
const _hoisted_37 = { key: 0 }
const _hoisted_38 = {
  key: 1,
  class: "truncate text-sm text-gray-500 leading-6"
}
const _hoisted_39 = { key: 0 }
const _hoisted_40 = { class: "flex justify-between mt-4" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "13",
  height: "12",
  viewBox: "0 0 13 12",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M1 6L5.75 1.25M1 6L5.75 10.75M1 6L12.0833 6",
    stroke: "#344054",
    "stroke-width": "1.58333",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 bg-black/25" }, null, -1))
const _hoisted_43 = { class: "fixed inset-0 overflow-y-auto" }
const _hoisted_44 = { class: "flex min-h-full items-center justify-center p-4 text-center" }
const _hoisted_45 = { class: "mt-2" }
const _hoisted_46 = { class: "text-sm text-gray-500" }
const _hoisted_47 = { class: "mt-4" }

import { ref, watch, computed, onBeforeMount } from "vue";
import { useSchoolGroupStore } from "@/stores/schoolGroupsStore";
import { useWondeApiStore } from "@/stores/wondeStore";
import { useProductStore } from '@/stores/productStore';
import TabView from "primevue/tabview";
import TabPanel from "primevue/tabpanel";
import {
  Dialog,
  DialogPanel,
  DialogTitle,
  TransitionChild,
  TransitionRoot,
} from "@headlessui/vue";
import { School } from "@/interfaces/school.interface";
import i18n from "@/plugins/i18n";

//store
interface SelectOption {
  label: string;
  value: string;
  attrs: Array<any>;
}

// Fetch school groups on component mount

export default /*#__PURE__*/_defineComponent({
  __name: 'InternalWondeImportView',
  setup(__props) {

const schoolGroupsStore = useSchoolGroupStore();
const wondeStore = useWondeApiStore();

const productStore = useProductStore();
//refs
const loading = ref(false);
const loadingStructure = ref(false);
const selectedSchool = ref<string>("");
const schoolGroupOptions = ref<string>("");
let allWondeSchools = ref([]);
let existingSchools = ref([]);
const wondeSchoolOptions = ref<SelectOption[]>([]);
const selectedWondeSchoolId = ref<string>("");
const wondeSchoolClasses = ref([]);
const wondeSchoolTeachers = ref([]);
const responseModalVisible = ref(false);
const responseModal = ref({
  title: i18n.global.t("students_view.no_assigned_classes"),
  description: i18n.global.t("internal_view.wonde.school_created_success"),
  buttonText: "Okay",
});

const schoolObject = ref<School>({
  _id: "",
  classGroups: [] as string[],
  gradeLevels: [] as number[],
  name: "",
  description: "",
  language: "",
  domain: "",
  status: "",
  emisNumber: "",
  schoolGroup: "",
  gradeNamingConvention: "",
  schoolLicense: "",
  academicYearStart: "",
  academicYearEnd: "",
  location: {
    city: "",
    country: "",
  },
  preferredLang: "",
  wondeId: "",
  wondeApi: "",
  schoolLicenseData: {
    type: "",
    startDate: "",
    endDate: "",
    status: "",
    products: [
      {
        _id: "",
        maxSeats: 0,
        name: "",
        title: "",
      },
    ],
  },
});

onBeforeMount(async () => {
  loading.value = true;
  allWondeSchools.value = await wondeStore.getSchools();
  existingSchools.value = await wondeStore.getExistingSchools();
  wondeSchoolOptions.value = allWondeSchools.value?.data?.map((school) => {
    let formSettings = {
      label: school.name,
      value: school.id,
    };
    const exists = existingSchools.value.find(
      (existingSchool) => existingSchool.wondeId === school.id
    );
    if (exists) {
      formSettings.label = `${school.name} - (Already exists)`;
      formSettings.attrs = {
        disabled: true,
      };
    }
    return formSettings;
  });
  loading.value = false;
});

/**
 * Selected School show details and populate fields
 */
watch(
  selectedWondeSchoolId,
  async (newVal) => {
    if (newVal) {
      selectedSchool.value = allWondeSchools.value.data.find(
        (school) => school.id === newVal
      );
      if (selectedSchool.value) {
        schoolObject.value = {
          wondeId: selectedSchool.value.id,
          wondeApi: selectedSchool.value.region.domain,
          name: selectedSchool.value.name,
          description: `PHASE: ${selectedSchool.value.phase_of_education}. CODE: ${selectedSchool.value.la_code}. URN: ${selectedSchool.value.urn}. MIS: ${selectedSchool.value.mis}. Establishment Number: ${selectedSchool.value.establishment_number}`,
          location: {
            city: selectedSchool.value.address.address_town,
            country: selectedSchool.value.address.address_country.name,
          },
          schoolLicenseData: {
            type: "annual",
            startDate: new Date().toISOString(),
            endDate: new Date().toISOString(),
            products: productStore.products.map(product => ({
              product: product._id,
              maxSeats: 0,
              seatsUsed: 0
            })),
          },
        };
      }
    }
  },
  {
    deep: true,
  }
);
/**
 * Populate Classes, Teachers & Students Tabs when school is selected
 */
watch(
  selectedWondeSchoolId,
  async (newVal) => {
    if (newVal) {
      const currentSchool = allWondeSchools.value.data.find(
        (school) => school.id === newVal
      );
      loadingStructure.value = true;
      try {
        const [schoolEntities, schoolGroups] = await Promise.all([
          wondeStore.getSchoolEntities(currentSchool.id),
          schoolGroupsStore.fetchSchoolGroups(),
        ]);
        wondeSchoolClasses.value = schoolEntities.classGroups;
        wondeSchoolTeachers.value = schoolEntities.teachers;
        filterTeachersByClasses();
        const schoolGroupEntries = schoolGroupsStore.getSchoolGroups;
        schoolGroupOptions.value = schoolGroupEntries.map((group) => {
          return {
            label: group.name,
            value: group._id,
          };
        });
        //set grade levels input value
        const uniqueGrades = new Set<number>();
        wondeSchoolClasses.value.forEach((classGroup) => {
          uniqueGrades.add(classGroup.grade);
        });
        const sortedGrades = Array.from(uniqueGrades).sort((a, b) => a - b);
        if (sortedGrades)
          schoolObject.value.gradeLevels = sortedGrades.join(",");
      } catch (error) {
        showResponseModal("Error", error.message, "Okay");
      }
      loadingStructure.value = false;
    }
  },
  {
    deep: true,
  }
);

/**
 * Convert the date to MM-DD format required by model
 * @param dateString
 * @returns string
 */
const formatDateToMMYY = (dateString: string): string => {
  const date = new Date(dateString);
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${month}-${day}`;
};

/**
 * Extract domain name from URL if necessary
 */
const extractDomainName = (url: string): string => {
  const domainPattern = /^(?:https?:\/\/)?(?:www\.)?([^/]+)/i;
  const match = url.match(domainPattern);
  return match ? match[1] : "";
};

/**
 * Save and Sync School
 */
const saveAndSync = async () => {
  if (schoolObject.value) {
    schoolObject.value.gradeLevels = schoolObject.value.gradeLevels
      ?.split(",")
      .map((grade) => parseInt(grade));
    schoolObject.value.academicYearStart = formatDateToMMYY(
      schoolObject.value.academicYearStart
    );
    schoolObject.value.academicYearEnd = formatDateToMMYY(
      schoolObject.value.academicYearEnd
    );
    schoolObject.value.wondeApi = extractDomainName(
      schoolObject.value.wondeApi
    );
    //set end date
    const licenseStartDate = schoolObject.value.schoolLicenseData.startDate;
    schoolObject.value.schoolLicenseData.endDate = new Date(
      new Date().setFullYear(new Date(licenseStartDate).getFullYear() + 1)
    ).toISOString();
    const savedSchool = await wondeStore
      .createSchool(schoolObject.value)
      .then(function (response) {
        if (response.success === true) {
          wondeStore.triggerJobSync(response.data.wondeId);
          showResponseModal(
            "Success!",
            "School created and the sync operations have begun. Check back later to see the results.",
            "OK"
          );
        } else {
          showResponseModal(
            "Error",
            "There was a problem with the request.",
            "Okay"
          );
        }
      })
      .catch(function (error) {
        showResponseModal("Error", error.message, "Okay");
      });
  } else {
    showResponseModal(
      "Error",
      "There was a problem with the school data, refresh and try again.",
      "Okay"
    );
  }
};

/**
 * Toggle Modal visibility and set the content
 */
const closeResponseModal = async () => {
  responseModalVisible.value = false;
};
const showResponseModal = async (
  title?: string,
  description?: string,
  btnText?: string
) => {
  responseModal.value = {
    title: title ? title : responseModal.value.title,
    description: description ? description : responseModal.value.description,
    buttonText: btnText ? btnText : responseModal.value.buttonText,
  };
  responseModalVisible.value = true;
};

/**
 * Only show teachers within the selected classes
 */
const filterTeachersByClasses = () => {
  const classIds = new Set(
    wondeSchoolClasses.value.map((schoolClass) => schoolClass.id)
  );
  const filteredTeachers = wondeSchoolTeachers.value.filter((teacher) => {
    const hasValidClass = teacher.classes.data.some((cls) =>
      classIds.has(cls.id)
    );
    const hasValidGroup = teacher.groups.data.some((grp) =>
      classIds.has(grp.id)
    );
    return hasValidClass || hasValidGroup;
  });

  wondeSchoolTeachers.value = filteredTeachers;
  return;
};

/**
 * Computed Properties for ClassGroups
 */
const mathsClasses = computed(() => {
  return wondeSchoolClasses.value
    .filter((group) => group.subject.toLowerCase() === "maths")
    .sort((a, b) => b.grade - a.grade);
});
const englishClasses = computed(() => {
  return wondeSchoolClasses.value
    .filter((group) => group.subject.toLowerCase() === "english")
    .sort((a, b) => b.grade - a.grade);
});
const allGrades = computed(() => {
  const grades = wondeSchoolClasses.value.map((group) => group.grade);
  const uniqueGrades = [...new Set(grades)];
  return uniqueGrades.sort((a, b) => b - a);
});

return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!
  const _component_spinner_loader = _resolveComponent("spinner-loader")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t("internal_view.wonde.header")), 1),
        _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t("internal_view.wonde.description")), 1),
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_FormKit, {
            type: "select",
            label: "Wonde Schools",
            placeholder: "Select a School",
            name: "school",
            modelValue: selectedWondeSchoolId.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedWondeSchoolId).value = $event)),
            "outer-class": "primary-select",
            options: wondeSchoolOptions.value,
            classes: {
            outer: 'w-1/2',
          },
            disabled: loading.value
          }, null, 8, ["modelValue", "options", "disabled"]),
          (loading.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                _createVNode(_component_spinner_loader, { color: 'text-rl-base-blue-500' })
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      (selectedSchool.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createVNode(_unref(TabView), { class: "mt-9" }, {
              default: _withCtx(() => [
                _createVNode(_unref(TabPanel), { header: "School details" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_FormKit, {
                      type: "form",
                      id: "login-form",
                      actions: false,
                      onSubmit: saveAndSync
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_9, [
                          _createVNode(_component_FormKit, {
                            disabled: "",
                            type: "text",
                            label: "Wonde ID",
                            "outer-class": "primary-select",
                            placeholder: "Wonde ID",
                            modelValue: schoolObject.value.wondeId,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((schoolObject.value.wondeId) = $event))
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_FormKit, {
                            type: "select",
                            label: "School Group *",
                            placeholder: "Select Group",
                            name: "group",
                            modelValue: schoolObject.value.schoolGroup,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((schoolObject.value.schoolGroup) = $event)),
                            "outer-class": "primary-select",
                            options: schoolGroupOptions.value,
                            validation: "required",
                            "validation-messages": {
                  required: 'A School Group is required.',
                }
                          }, null, 8, ["modelValue", "options", "validation-messages"])
                        ]),
                        _createElementVNode("div", _hoisted_10, [
                          _createVNode(_component_FormKit, {
                            type: "text",
                            label: "City",
                            "outer-class": "primary-select",
                            placeholder: "City name",
                            modelValue: schoolObject.value.location.city,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((schoolObject.value.location.city) = $event))
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_FormKit, {
                            type: "text",
                            label: "Country",
                            "outer-class": "primary-select",
                            placeholder: "Country name",
                            modelValue: schoolObject.value.location.country,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((schoolObject.value.location.country) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_11, [
                          _createVNode(_component_FormKit, {
                            type: "select",
                            label: "Grade naming convention *",
                            "outer-class": "primary-select",
                            placeholder: "Grade naming convention",
                            modelValue: schoolObject.value.gradeNamingConvention,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((schoolObject.value.gradeNamingConvention) = $event)),
                            options: {
                  grade: 'Grade',
                  year: 'Year',
                  level: 'Level',
                },
                            validation: "required",
                            "validation-messages": {
                  required: 'Grade naming convention is required.',
                }
                          }, null, 8, ["modelValue", "validation-messages"]),
                          _createVNode(_component_FormKit, {
                            type: "text",
                            label: "Grade Levels *",
                            "outer-class": "primary-select",
                            placeholder: "Grade levels (comma separated)",
                            modelValue: schoolObject.value.gradeLevels,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((schoolObject.value.gradeLevels) = $event)),
                            validation: "required",
                            "validation-messages": {
                  required:
                    'Grade levels are required and should be comma separated.',
                }
                          }, null, 8, ["modelValue", "validation-messages"])
                        ]),
                        _createElementVNode("div", _hoisted_12, [
                          _createVNode(_component_FormKit, {
                            type: "select",
                            options: {
                'en-ZA': 'English - South Africa',
                'af-ZA': 'Afrikaans - South Africa',
                'en-AU': 'English - Australia',
                'en-UK': 'English - United Kingdom',
                'en-GB': 'English - Great Britain',
                'en-ND': 'English - ND',
              },
                            label: "Assessment Language",
                            validation: "required",
                            "outer-class": "primary-select",
                            placeholder: "Select Assessment Language",
                            modelValue: schoolObject.value.preferredLang,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((schoolObject.value.preferredLang) = $event))
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_FormKit, {
                            type: "date",
                            label: "License Start Date",
                            "outer-class": "primary-select",
                            placeholder: "License Start Date",
                            modelValue: schoolObject.value.schoolLicenseData.startDate,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((schoolObject.value.schoolLicenseData.startDate) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_13, [
                          _createVNode(_component_FormKit, {
                            type: "select",
                            label: "License type",
                            "outer-class": "primary-select",
                            placeholder: "License type",
                            name: "type",
                            options: ['annual', 'trial'],
                            modelValue: schoolObject.value.schoolLicenseData.type,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((schoolObject.value.schoolLicenseData.type) = $event))
                          }, null, 8, ["modelValue"]),
                          _createElementVNode("div", _hoisted_14, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(productStore).products, (product) => {
                              return (_openBlock(), _createBlock(_component_FormKit, {
                                key: product._id,
                                type: "number",
                                name: `product_${product._id}`,
                                label: `${product.name} Seats`,
                                placeholder: "Enter number of seats",
                                validation: "required|min:0",
                                validationMessages: {
                  required: 'Number of seats is required',
                  min: 'At least 0 seat is required',
                },
                                classes: { outer: 'col-span-2' },
                                modelValue: schoolObject.value.schoolLicenseData.products.find(p => p.product === product._id).maxSeats,
                                "onUpdate:modelValue": ($event: any) => ((schoolObject.value.schoolLicenseData.products.find(p => p.product === product._id).maxSeats) = $event)
                              }, null, 8, ["name", "label", "modelValue", "onUpdate:modelValue"]))
                            }), 128))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_15, [
                          _createVNode(_component_FormKit, {
                            type: "date",
                            label: "General date of academic year start *",
                            "outer-class": "primary-select",
                            modelValue: schoolObject.value.academicYearStart,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((schoolObject.value.academicYearStart) = $event)),
                            validation: "required",
                            "validation-messages": {
                  required: 'Academic Year Start is required.',
                }
                          }, null, 8, ["modelValue", "validation-messages"]),
                          _createVNode(_component_FormKit, {
                            type: "date",
                            label: "General date of academic year end *",
                            "outer-class": "primary-select",
                            modelValue: schoolObject.value.academicYearEnd,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((schoolObject.value.academicYearEnd) = $event)),
                            validation: "required",
                            "validation-messages": {
                  required: 'Academic Year End is required.',
                }
                          }, null, 8, ["modelValue", "validation-messages"])
                        ]),
                        _createElementVNode("div", _hoisted_16, [
                          _createVNode(_component_FormKit, {
                            type: "text",
                            label: "EMIS number",
                            "outer-class": "primary-select",
                            placeholder: "EMIS number",
                            modelValue: schoolObject.value.emisNumber,
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((schoolObject.value.emisNumber) = $event))
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_FormKit, {
                            type: "text",
                            label: "Domain name *",
                            "outer-class": "primary-select",
                            placeholder: "schoolname.com",
                            modelValue: schoolObject.value.domain,
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((schoolObject.value.domain) = $event)),
                            validation: [
                  ['required'],
                  [
                    'matches',
                    /^[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/,
                  ],
                ],
                            "validation-messages": {
                  required:
                    'Domain name is required. Students without email addresses will be created using this domain.',
                  matches:
                    'Domain name needs to be in a format like schoolname.com or school.area.sch.uk',
                }
                          }, null, 8, ["modelValue", "validation", "validation-messages"])
                        ]),
                        _createElementVNode("div", _hoisted_17, [
                          _createVNode(_component_FormKit, {
                            type: "text",
                            name: "description",
                            label: "Description",
                            placeholder: "General description of the school.",
                            "outer-class": "primary-select",
                            class: "primary-select",
                            modelValue: schoolObject.value.description,
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((schoolObject.value.description) = $event))
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_FormKit, {
                            type: "hidden",
                            name: "wondeApi",
                            modelValue: schoolObject.value.wondeApi,
                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((schoolObject.value.wondeApi) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_18, [
                          _createVNode(_component_FormKit, {
                            type: "submit",
                            class: "mb-1 mt-9 inline-block w-full bg-[#756FF3] shadow-[0px 4px 10px 0px] shadow-md text-base font-medium leading-normal text-white mt-8",
                            inputClass: "mt-6 px-6 py-[10px]"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("internal_view.wonde.btn_create_and_sync")), 1)
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(TabPanel), { header: "Grades & Classes" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("ul", null, [
                        _createElementVNode("li", null, [
                          _createElementVNode("h2", _hoisted_20, [
                            _createTextVNode(_toDisplayString(_ctx.$t("internal_view.wonde.all_classgroups")) + " ", 1),
                            (loadingStructure.value)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_21, [
                                  _createVNode(_component_spinner_loader, { color: 'text-rl-base-blue-500 w-4 h-4' })
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allGrades.value, (grade) => {
                          return (_openBlock(), _createElementBlock("li", {
                            class: "inline-flex mr-1 ml-2 mb-2",
                            key: grade
                          }, [
                            _createElementVNode("span", _hoisted_22, _toDisplayString(grade), 1)
                          ]))
                        }), 128)),
                        _hoisted_23,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mathsClasses.value, (group) => {
                          return (_openBlock(), _createElementBlock("li", {
                            class: "inline-flex mr-1 ml-2 mb-2",
                            key: group.gradeClass
                          }, [
                            _createElementVNode("span", _hoisted_24, _toDisplayString(group.gradeClass), 1)
                          ]))
                        }), 128)),
                        _hoisted_25,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(englishClasses.value, (group) => {
                          return (_openBlock(), _createElementBlock("li", {
                            class: "inline-flex mr-1 ml-2 mb-2",
                            key: group.gradeClass
                          }, [
                            _createElementVNode("span", _hoisted_26, _toDisplayString(group.gradeClass), 1)
                          ]))
                        }), 128))
                      ])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_unref(TabPanel), { header: "Teacher details" }, {
                  default: _withCtx(() => [
                    _createElementVNode("h2", _hoisted_27, [
                      _createTextVNode(_toDisplayString(_ctx.$t("internal_view.wonde.all_teachers")) + " ", 1),
                      (loadingStructure.value)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_28, [
                            _createVNode(_component_spinner_loader, { color: 'text-rl-base-blue-500 w-4 h-4' })
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_29, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(wondeSchoolTeachers.value, (teacher) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "relative flex items-center space-x-3 rounded-lg border border-gray-300 bg-white px-6 py-5 shadow-sm focus-within:ring-2 focus-within:ring-indigo-500 focus-within:ring-offset-2 hover:border-gray-400",
                          key: teacher.id,
                          style: {"color":"#000"}
                        }, [
                          _hoisted_30,
                          _createElementVNode("div", _hoisted_31, [
                            _createElementVNode("a", _hoisted_32, [
                              _hoisted_33,
                              _createElementVNode("p", _hoisted_34, _toDisplayString(teacher.title) + " " + _toDisplayString(teacher.forename) + " " + _toDisplayString(teacher.surname), 1),
                              _createElementVNode("p", _hoisted_35, _toDisplayString(teacher.contact_details?.data?.emails.email), 1),
                              (teacher.classes.data.length > 0)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_36, [
                                    _createTextVNode(" Classes: "),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(teacher.classes.data, (classItem, index) => {
                                      return (_openBlock(), _createElementBlock("span", { key: index }, [
                                        _createTextVNode(_toDisplayString(classItem.name), 1),
                                        (index < teacher.classes.data.length - 1)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_37, ", "))
                                          : _createCommentVNode("", true)
                                      ]))
                                    }), 128))
                                  ]))
                                : _createCommentVNode("", true),
                              (teacher.groups.data.length > 0)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_38, [
                                    _createTextVNode(" Groups: "),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(teacher.groups.data, (groupItem, index) => {
                                      return (_openBlock(), _createElementBlock("span", {
                                        key: index,
                                        class: "font-semibold"
                                      }, [
                                        _createTextVNode(_toDisplayString(groupItem.name), 1),
                                        (index < teacher.groups.data.length - 1)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_39, ", "))
                                          : _createCommentVNode("", true)
                                      ]))
                                    }), 128))
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]))
                      }), 128))
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_40, [
        _createVNode(_component_router_link, {
          to: "/main/internal",
          class: "font-semibold text-[#344054] text-base border-[#D0D5DD] border rounded-lg py-2 px-4 flex items-center shadow-[0px_1px_2px_0px_rgba(16,24,40,0.05)] bg-white gap-2"
        }, {
          default: _withCtx(() => [
            _hoisted_41,
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('internal_tools.school_group.btn_back')), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_unref(TransitionRoot), {
      appear: "",
      show: responseModalVisible.value,
      as: "template"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Dialog), {
          as: "div",
          onClose: closeResponseModal,
          class: "relative z-10"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(TransitionChild), {
              as: "template",
              enter: "duration-300 ease-out",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "duration-200 ease-in",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: _withCtx(() => [
                _hoisted_42
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_43, [
              _createElementVNode("div", _hoisted_44, [
                _createVNode(_unref(TransitionChild), {
                  as: "template",
                  enter: "duration-300 ease-out",
                  "enter-from": "opacity-0 scale-95",
                  "enter-to": "opacity-100 scale-100",
                  leave: "duration-200 ease-in",
                  "leave-from": "opacity-100 scale-100",
                  "leave-to": "opacity-0 scale-95"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(DialogPanel), { class: "w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(DialogTitle), {
                          as: "h3",
                          class: "text-lg font-medium leading-6 text-gray-900"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(responseModal.value.title), 1)
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", _hoisted_45, [
                          _createElementVNode("p", _hoisted_46, _toDisplayString(responseModal.value.description), 1)
                        ]),
                        _createElementVNode("div", _hoisted_47, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "inline-flex justify-center rounded-md border border-transparent bg-blue-100 px-4 py-2 text-sm font-medium text-blue-900 hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2",
                            onClick: closeResponseModal
                          }, _toDisplayString(responseModal.value.buttonText), 1)
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}
}

})